(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('PartnerUserEditController', PartnerUserEditController);

    PartnerUserEditController.$inject = ['$uibModalInstance','partner','ManagePartnersService'];

    function PartnerUserEditController($uibModalInstance, partner, ManagePartnersService) {
        var vm = this;
        vm.partner          = [];
        vm.ok               = ok;
        vm.cancel           = cancel;
        vm.update           = update;

        angular.copy(partner, vm.partner);

        vm.name                 = vm.partner.name;
        vm.email                = vm.partner.email;
        vm.password             = '';
        vm.function             = vm.partner.function;
        vm.shortDescription     = vm.partner.shortDescription;
        vm.socialSkype          = vm.partner.socialSkype;
        vm.socialFacebook       = vm.partner.socialFacebook;
        vm.socialTwitter        = vm.partner.socialTwitter;
        vm.socialLinkedin       = vm.partner.socialLinkedin;
        vm.socialGooglePlus     = vm.partner.socialGooglePlus;
        vm.phone                = vm.partner.phone;

        activate();

        function activate() {

        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {

            vm.fields = {
                name                : vm.name,
                email               : vm.email,
                password            : vm.password,
                function            : vm.function,
                shortDescription    : vm.shortDescription,
                socialSkype         : vm.socialSkype,
                socialFacebook      : vm.socialFacebook,
                socialTwitter       : vm.socialTwitter,
                socialLinkedin      : vm.socialLinkedin,
                socialGooglePlus    : vm.socialGooglePlus,
                phone               : vm.phone
            };

            ManagePartnersService.updatePartnerUser(vm.partner.id, vm.fields).then(function(response){
                if (response.errors) {
                    vm.formErrors = response.errors;
                } else {
                    alertify.success('Partner User successfully updated');
                    partner.name = vm.name;
                    partner.email = vm.email;
                    partner.password = vm.password;
                    partner.function = vm.function;
                    partner.shortDescription = vm.shortDescription;
                    partner.socialSkype = vm.socialSkype;
                    partner.socialFacebook = vm.socialFacebook;
                    partner.socialTwitter = vm.socialTwitter;
                    partner.socialLinkedin = vm.socialLinkedin;
                    partner.socialGooglePlus = vm.socialGooglePlus;
                    partner.phone = vm.phone;
                    ok();
                }
            }).catch(function(err) {
                alertify.error(err);
            });
        }
    }

})();